import { c as _c } from "react/compiler-runtime";
import type { SubmissionMediaCategory } from '@/constants/submission-media.constants';
import { CubeIcon, FilmIcon, PhotoIcon } from '@heroicons/react/24/outline';
import React from 'react';

/**
 * Props for the FileTypeIndicator component
 */
interface FileTypeIndicatorProps {
  readonly kind: SubmissionMediaCategory;
  readonly label: string;
}

/**
 * File Type Indicator Component
 * 
 * Displays a visual indicator for supported file formats.
 * Used in the upload area to show what types of files are accepted.
 * 
 * @param props Component props
 * @returns JSX Element
 */
const ICON_BY_KIND: Record<SubmissionMediaCategory, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  image: PhotoIcon,
  video: FilmIcon,
  interactive: CubeIcon
};
const FileTypeIndicator: React.FC<FileTypeIndicatorProps> = t0 => {
  const $ = _c(7);
  const {
    kind,
    label
  } = t0;
  const Icon = ICON_BY_KIND[kind];
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon className="tw-size-4 tw-flex-shrink-0 tw-text-iron-500" aria-hidden="true" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="tw-whitespace-nowrap">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-text-[10px] tw-font-semibold tw-text-iron-400 tw-tracking-wider tw-bg-iron-800/50 tw-border tw-border-iron-800 tw-rounded-full tw-border-solid">{t1}{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default FileTypeIndicator;